export default __webpack_public_path__ + "ac1127ea50665a5d9719b80b34961a49.png";